export class Cotizacion {

constructor(
    public origen: number, 
    public destino: number, 
    public tipo: number,
    public inicio: string,
    public fin: string,
    public email: string,
    public estadia: number,
    public e1: string,
    public e2: string,
    public e3: string,
    public e4: string,
    public e5: string,
    public e6: string,
    public e7: string,
    public e8: string,
    public aseguradora: string,
    public ordenamiento: string,
    public terminos: boolean
    )    
{}
}



// WEBPACK FOOTER //
// ./src/app/obj/cotizacion.ts